import {
    get,post
} from '@/server/request.js';
export default {
	// 首页数据
	getInfo(data) {
        return post('Index/index', data)
	},
    // 订单列表
    getIndexList(data) {
        return post('Order/getList', data)
	},
    // 接单
    getOrder(data) {
        return post('Order/getOrder', data)
	},
    // 订单详情
    getOrderInfo(data) {
        return post('Order/getInfo', data)
	},
    
    // 职位列表
    getjobType(data) {
        return post('Order/treeCategory', data)
	},
    // 我的订单列表
    getMyOrderList(data) {
        return post('Order/my', data)
	},

    // 个人中心列表
    getMyOrderpayList(data) {
        return post('Order/payList', data)
	},
    // 个人中心明细
    getMyOrderPayDetailt(data) {
        return post('Order/payDetail', data)
	},
    // 文章
    getCon(data) {
        return post('Common/getCon', data)
	},
    // 图片上传Common/upload
    picUpload(data) {
        return post('Common/upload', data)
	},
    // 文件上传
    uploadFile(data) {
        return post('Common/uploadFile', data)
	},
    // 修改简历
    updateResume(data) {
        return post('Order/updateResume', data)
	},
    // 注册
    register(data) {
        return post('Login/register', data)
	},
    // 登录
    login(data) {
        return post('Login/login', data)
	},
    // 获取验证key
    getVerify(data) {
        return post('Login/getVerify', data)
	},
    // 发送
    sendSms(data) {
        return post('Login/sendSms', data)
	},
    // 地址
    CityIndex(data) {
        return post('City/index', data)
	},
    // 推荐列表
    getRecommendList(data) {
        return post('Order/getRecommendList', data)
	},
    getConfig(data) {
        return post('Common/getConfig', data)
	},
    // 提交简历l
    uploadResume(data) {
        return post('Order/uploadResume', data)
	}, 
    // 提现
    apply(data) {
        return post('Withdraw/apply', data)
	},
    // 提现记录
    getList(data) {
        return post('Withdraw/getList', data)
	},
    // 用户信息
    UserIndex(data) {
        return post('User/index', data)
	},
      getMyReferrals(data) {
        return post('User/getMyReferrals', data)
	},

   teamCommissionList(data) {
        return post('Order/teamCommissionList', data)
	},


}